var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      attrs: {
        id: "editCreatorPasswordAndReferrerModal",
        title: "Edit Password or Referrer"
      },
      on: {
        close: function($event) {
          return _vm.getFormData()
        }
      }
    },
    [
      _c(
        "form",
        {
          attrs: { id: "creator_referrer_form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitModalForm.apply(null, arguments)
            }
          }
        },
        [
          _c("AppInput", {
            staticClass: "form-group align-items-center",
            attrs: {
              label: _vm.$t("Referrer"),
              error:
                _vm.ajax_error &&
                _vm.ajax_error.errors &&
                _vm.ajax_error.errors.ref,
              placeholder: _vm.$t("Referrer"),
              name: "ref",
              "data-test-id": "Referrer"
            },
            model: {
              value: _vm.form.ref,
              callback: function($$v) {
                _vm.$set(_vm.form, "ref", $$v)
              },
              expression: "form.ref"
            }
          }),
          _vm._v(" "),
          _c("AppInput", {
            staticClass: "form-group",
            attrs: {
              label: _vm.$t("Password"),
              error:
                _vm.ajax_error &&
                _vm.ajax_error.errors &&
                _vm.ajax_error.errors.password,
              placeholder: _vm.$t("Password"),
              type: "password",
              name: "password",
              "data-test-id": "password-input"
            },
            model: {
              value: _vm.form.password,
              callback: function($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password"
            }
          }),
          _vm._v(" "),
          _c("AppInput", {
            staticClass: "form-group",
            attrs: {
              label: _vm.$t("Confirm Password"),
              error:
                _vm.ajax_error &&
                _vm.ajax_error.errors &&
                _vm.ajax_error.errors.password_confirmation,
              placeholder: _vm.$t("Confirm Password"),
              type: "password",
              name: "password_confirmation",
              "data-test-id": "password-confirm"
            },
            model: {
              value: _vm.form.password_confirmation,
              callback: function($$v) {
                _vm.$set(_vm.form, "password_confirmation", $$v)
              },
              expression: "form.password_confirmation"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-wrap justify-content-end mt-3" },
            [
              _c(
                "AppButton",
                {
                  staticClass: "py-2 md-flat ml-2 mt-1",
                  staticStyle: { width: "100px" },
                  attrs: {
                    name: "close-modal-edit-creator-referrer",
                    outline: "",
                    type: "button",
                    "data-dismiss": "modal"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Close")))]
              ),
              _vm._v(" "),
              _c(
                "AppButton",
                {
                  staticClass: "py-2 md-flat ml-2 mt-1",
                  staticStyle: { width: "100px" },
                  attrs: {
                    name: "save-modal-edit-creator-referrer",
                    type: "Submit"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }